import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { history } from "./Core/Store"
import _Routes from './Core/Routes'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { Toaster } from 'react-hot-toast';



export default function RouterApp(props) {



  return (

    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
        }}
      />
      <_Routes history={history} />
    </div>

  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(<RouterApp />);

// test
serviceWorkerRegistration.register();

reportWebVitals();
